import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validators for French Real Estate Agent Cards
 * Rules based on CCI standards:
 * - CPI (Carte Professionnelle Immobilière): CPI + 17 digits (20 chars)
 * - ADC (Attestation de Collaborateur): ADC + 13 digits (16 chars)
 * - RPA (Récépissé de Déclaration Préalable): RPA + 13 digits (16 chars)
 */
export class AgentCardValidators {
  static format(expectedPrefixFn?: () => string | undefined): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const raw = control.value?.toString().replace(/\s/g, ''); // Remove spaces
      if (!raw) return null;

      const upperValue = raw.toUpperCase();
      const prefix = upperValue.substring(0, 3);
      const digits = upperValue.substring(3);
      const isDigitsOnly = /^\d+$/.test(digits);

      const validPrefixes = ['CPI', 'ADC', 'RPA', 'LPS'];

      if (!validPrefixes.includes(prefix)) {
        return { agentCardPrefix: true };
      }

      const expectedPrefix = expectedPrefixFn?.();
      if (expectedPrefix && prefix !== expectedPrefix) {
        return { agentCardPrefixMismatch: { expected: expectedPrefix, actual: prefix } };
      }

      if (!isDigitsOnly) {
        return { agentCardDigits: true };
      }

      // All modern CCI cards (CPI, ADC, RPA, LPS) are strictly 20 characters (3 prefix letters + 17 digits)
      if (upperValue.length !== 20) {
        return { agentCardLength: { required: 20, actual: upperValue.length } };
      }

      return null;
    };
  }
}
